/**
 * Visual appearance for a scene-graph edge based on its semantic edgeType.
 * Pure function — same input produces same output, safe to call during render.
 */
export function getSceneGraphEdgeProps(edge) {
  switch (edge.edgeType) {
    case "body-parent-child":
      return { stroke: "#9ca3af", strokeWidth: 2, dasharray: undefined, opacity: 1 };
    case "body-satellite":
      return { stroke: "#6b7280", strokeWidth: 1.5, dasharray: "4 3", opacity: 0.8 };
    case "fixed-ground":
      return { stroke: "#9ca3af", strokeWidth: 1.8, dasharray: undefined, opacity: 0.95 };
    case "actuator-joint":
      return { stroke: "#fbbf24", strokeWidth: 1.5, dasharray: "5 3", opacity: 0.8 };
    case "actuator-tendon":
      return { stroke: "#fbbf24", strokeWidth: 1.5, dasharray: "5 3", opacity: 0.8 };
    case "tendon-joint":
      return { stroke: "#38bdf8", strokeWidth: 1.5, dasharray: "4 3", opacity: 0.8 };
    case "camera-mount":
      return { stroke: "#4ade80", strokeWidth: 1.5, dasharray: "5 3", opacity: 0.75 };
    case "equality-ref":
      return { stroke: "#a78bfa", strokeWidth: 1.5, dasharray: "5 3", opacity: 0.8 };
    default:
      return { stroke: "#6b7280", strokeWidth: 1, dasharray: undefined, opacity: 0.4 };
  }
}
